/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import MonthlyListView from '../../view/pages/monthly/ListView'
import MonthlyClosingHeadsStore from '../../store/monthly_closing/MonthlyClosingHeadsStore'
import MonthlyClosingSearchStore from '../../store/monthly_closing/MonthlyClosingSearchStore'
import DailyClosingHeadsStore from '../../store/monthly_closing/DailyClosingHeadsStore'
import MonthlyClosingAction from '../../action/monthly_closing'
import LocalDate from '../../domain/type/Date'
import NProgress from 'nprogress'

class ListContainer extends Component {
  static getStores() {
    return [MonthlyClosingHeadsStore, MonthlyClosingSearchStore, DailyClosingHeadsStore]
  }

  static calculateState(prevState, props) {
    return {
      heads: MonthlyClosingHeadsStore.getState(),
      search: MonthlyClosingSearchStore.getState(),
      daily_closings: DailyClosingHeadsStore.getState(),
      ...props
    }
  }

  async componentDidMount() {
    NProgress.start()
    const id = this.state.match.params.id
    if (id) {
      await MonthlyClosingAction.fetchDailySummaryById(id)
      NProgress.done()
      return
    }

    const date = this.state.match.params.date
    const monthly_close_date = date
      ? LocalDate.parse(date)
      : LocalDate.today()
          .lastMonth()
          .beginningOfMonth()

    if (this.state.showDetail) {
      const hotel_id = this.state.match.params.hotel_id
      if (hotel_id) {
        await MonthlyClosingAction.fetchDailySummaryByHotelId(hotel_id, monthly_close_date)
        NProgress.done()
        return
      }
    }

    await MonthlyClosingAction.fetchByDate(monthly_close_date, this.state.search.hotel_ids)
    NProgress.done()
  }

  render() {
    return MonthlyListView(this.state)
  }
}

export default withRouter(Container.create(ListContainer, { withProps: true }))
